// ─── widgets/video.js ─────────────────────────────────────────────────────────
// Creates cleverstory.v2.widgets.video objects from video / iframe elements.

import shortid from 'shortid';
import { cs, getAbsoluteRect } from '../utils/dom.js';
import { extractRGBAFromColor, extractShadowProperties, extractBorderRadius } from '../utils/style.js';
import { VIDEO } from 'constants/widgetTypes.jsx';

/**
 * @param {{ el, mobileEl, parentUid, offsetRect, mobileOffsetRect, orderRef }}
 */
export function createVideoWidgetObj({ el, mobileEl, parentUid, offsetRect, mobileOffsetRect, orderRef }) {
    const rect  = getAbsoluteRect(el);
    const mRect = mobileEl
        ? getAbsoluteRect(mobileEl)
        : {
            width:  Math.min(rect.width, 335),
            height: rect.height * (Math.min(rect.width, 335) / rect.width),
            top:    rect.top,
            left:   Math.min(rect.left, 20),
        };

    let src  = '';
    let type = 'video';
    if (el.tagName === 'IFRAME') {
        src  = el.getAttribute('src') || '';
        type = src.includes('youtube') ? 'youtube' : src.includes('vimeo') ? 'vimeo' : 'video';
    } else {
        src = el.querySelector('source')?.getAttribute('src') || el.getAttribute('src') || '';
    }

    const styleEl = (el.parentElement?.tagName === 'DIV' ? el.parentElement : null) || el;
    const style   = cs(styleEl);
    const border  = {
        sides:  null,
        color:  extractRGBAFromColor(style.borderColor),
        width:  parseFloat(style.borderWidth || '0').toString(),
        radius: extractBorderRadius(style),
    };
    const shadow      = extractShadowProperties(style.boxShadow);
    const contentType = type === 'youtube' ? 'video/youtube' : type === 'vimeo' ? 'video/vimeo' : 'video/mp4';

    const mOff = mobileOffsetRect || offsetRect;
    const vx  = Math.round(rect.left  - (offsetRect.left || 0));
    const vy  = Math.round(rect.top   - (offsetRect.top  || 0));
    const mvx = Math.round(mRect.left - (mOff.left || 0));
    const mvy = Math.round(mRect.top  - (mOff.top  || 0));

    return {
        uid:           `widget_${shortid.generate()}`,
        type:           VIDEO,
        name:          'Video',
        parent:        parentUid,
        order:         orderRef.value++,
        systemDefined: false,
        capabilities:  null,
        fonts:         null,
        actions:       null,
        parameter:     null,
        properties: {
            desktop: {
                visible: true,
                layout: {
                    transform: { translate: `${vx}px,${vy}px`, rotate: '0deg', scale: '1,1' },
                    width:  Math.round(rect.width)  + 'px',
                    height: Math.round(rect.height) + 'px',
                },
                shadow, border, crop: null, alt: null, position: null, animation: null,
            },
            mobile: {
                visible: true,
                layout: {
                    transform: { translate: `${mvx}px,${mvy}px`, rotate: '0deg' },
                    width:  Math.round(mRect.width)  + 'px',
                    height: Math.round(mRect.height) + 'px',
                },
                shadow, border, crop: null, alt: null, position: null, animation: null,
            },
        },
        content: { contentType, type: 'video', width: rect.width, height: rect.height, url: src },
    };
}